jQuery(document).ready(function ($) {
  //  Mood product custom Accordion
  //accordion();

  //
  if ($(".coupon-code-wrapp").length > 0) {
    var stickySection = jQuery(".coupon-code-wrapp").offset().top;
    // Add the sticky class to the section when it reaches the top of the page
    jQuery(window).scroll(function () {
      if (jQuery(window).scrollTop() > stickySection) {
        jQuery(".coupon-code-wrapp").addClass("coupon-sticky");
      } else {
        jQuery(".coupon-code-wrapp").removeClass("coupon-sticky");
      }
    });
  }

  //
  jQuery(".count").each(function () {
    jQuery(this)
      .prop("Counter", 0)
      .animate(
        {
          Counter: jQuery(this).text(),
        },
        {
          duration: 4000,
          easing: "swing",
          step: function (now) {
            jQuery(this).text(Math.ceil(now));
          },
        }
      );
  });

  //
  jQuery(".accordion-content:not(:first-of-type)").css("display", "none");
  jQuery(".js-accordion-title:first-of-type").addClass("open");
});

//
jQuery("#about_text").click(function () {
  jQuery(".popup").fadeIn(500);
});
jQuery(".close").click(function () {
  jQuery(".popup").fadeOut(500);
});

//
jQuery(".js-accordion-title").click(function () {
  jQuery(".open").not(this).removeClass("open").next().slideUp(300);
  jQuery(this).toggleClass("open").next().slideToggle(300);
});

//
jQuery(".load-more").on("click", function (e) {
  e.preventDefault();
  // alert('');
  jQuery(".product-info-each-hide").css("display", "block");
  jQuery(".load-more").hide();
});

//
jQuery(document).on('click', '.accordion-item', function () {
  if (jQuery(this).attr("id") !== "displayed") {
    jQuery(".accordion-item").removeAttr("id");
    jQuery(".accordion-item").find("#closed").css("display", "initial");
    jQuery(".desc").slideUp(100);

    jQuery(this).attr("id", "displayed");
    jQuery(this).children().last().slideDown(100);

    var closed = jQuery(this).find("#closed");
    closed.css("display", "none");
    jQuery(this).children().first().children().last().attr("class", "clicked");
  } else {
    jQuery(this).removeAttr("id");
    jQuery(this).children().last().slideUp(100);
    var closed = jQuery(this).find("#closed");
    closed.css("display", "initial");
  }
});

//
jQuery(document).on('click', '.tab-a', function () {
  jQuery(".tab").removeClass("tab-active");
  jQuery(".tab[data-id='" + jQuery(this).attr("data-id") + "']").addClass("tab-active");
  jQuery(".tab-a").removeClass("active-a");
  jQuery(this).parent().find(".tab-a").addClass("active-a");
})

//
$(".slick.marquee").slick({
  speed: 8000,
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: false,
  cssEase: "linear",
  slidesToShow: 3,
  draggable: true,
  focusOnSelect: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  slidesToScroll: 1,
  // variableWidth: true,
  infinite: true,
  initialSlide: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

//
$(".slick.marquee_rtl").slick({
  speed: 8000,
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: false,
  cssEase: "linear",
  draggable: true,
  focusOnSelect: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  // variableWidth: true,
  infinite: true,
  initialSlide: 1,
  arrows: false,
  rtl: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

//
$("#logo-list-slider").slick({
  dots: false,
  arrows: false,
  centerMode: true,
  infinite: true,
  autoplay: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});


if (jQuery('.formate-items').length && !jQuery('.formate-items').hasClass('slick-initialized')) {
  jQuery('.formate-items').slick({
    slidesToShow: 4,
    draggable: true,
    slidesToScroll: 1,
    infinite: false,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });
}


jQuery('#shopify-block-AOWxERTJZK1lJbk1BR__junip_product_reviews_ugc_junip_product_summary_QnR4nr, .product-content').wrapAll('<div class="rivew-content-wrapp"></div>');


/*
if (jQuery('.team-join').length) {
  // only init if not already initialized and there are at least 2 slides (optional)
  var $teamJoin = jQuery('.team-join');
  var slideCount = $teamJoin.children().length;
  if (!$teamJoin.hasClass('slick-initialized') && slideCount > 0) {
    $teamJoin.slick({
      slidesToShow: 2,
      draggable: true,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: { slidesToShow: 2, slidesToScroll: 1 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2, slidesToScroll: 1 }
        },
        {
          breakpoint: 500,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });
  }

  Ensure layout recalculation after images/load so slick can compute correct widths
  jQuery(window).on('load', function () {
    if ($teamJoin.hasClass('slick-initialized')) {
      $teamJoin.slick('setPosition');
    }
  });

  // In case images load later (cache), trigger setPosition when any slide image finishes loading
  $teamJoin.find('img').each(function () {
    if (this.complete) return;
    jQuery(this).on('load', function () {
      if ($teamJoin.hasClass('slick-initialized')) {
        $teamJoin.slick('setPosition');
      }
    });
  });
}
  */

/*
// Fix for Slick init + correct layout recalculation
jQuery(function ($) {
  var $teamJoin = $('.team-join');

  if ($teamJoin.length) {
    // count actual slide items
    var slideCount = $teamJoin.children('.item').length;

    // only init when not already initialized and there are enough slides
    // (use >1 because slidesToShow is 2; change to >0 if you want to init with a single slide)
    if (!$teamJoin.hasClass('slick-initialized') && slideCount > 1) {
      try {
        $teamJoin.slick({
          slidesToShow: 2,
          draggable: true,
          slidesToScroll: 1,
          infinite: false,
          autoplay: false,
          autoplaySpeed: 5000,
          arrows: true,
          responsive: [
            { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
          ]
        });
      } catch (err) {
        // helpful debug if slick isn't loaded
        // eslint-disable-next-line no-console
        console.error('Slick init failed:', err);
      }
    }

    // ensure layout recalculation after window load so slick can compute correct widths
    $(window).on('load', function () {
      if ($teamJoin.hasClass('slick-initialized')) {
        $teamJoin.slick('setPosition');
      }
    });

    // handle images that load after init (and cached images)
    $teamJoin.find('img').each(function () {
      var img = this;
      if (img.complete) {
        // if already loaded (cached), call setPosition immediately
        if ($teamJoin.hasClass('slick-initialized')) {
          $teamJoin.slick('setPosition');
        }
      } else {
        // otherwise attach load handler
        $(img).on('load', function () {
          if ($teamJoin.hasClass('slick-initialized')) {
            $teamJoin.slick('setPosition');
          }
        });
      }
    });
  }
});
*/

// jQuery(document).ready(function(){
//     jQuery('.team-join').slick({
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: true,
//       dots: false,
//       speed: 300,
//       infinite: true,
//       autoplaySpeed: 5000,
//       autoplay: true,
//       responsive: [
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 1,
//         }
//       }
//     ]
//   });
// });








/*
jQuery(document).ready(function(){
  jQuery('.team-join').slick({
    slidesToShow: 2.2,
    slidesToScroll: 1,
    arrows: true,
    // tell slick which elements to use for prev/next
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    dots: false,
    infinite: false, // set to true if you want looping
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  

  // OPTIONAL: add a class when first/last slide (if you need special styling)
  function updateBoundaryClasses(slick, currentSlide){
    var $prev = $('.slick-prev'), $next = $('.slick-next');
    if(currentSlide === 0) { $prev.addClass('slick-disabled'); } else { $prev.removeClass('slick-disabled'); }
    if(currentSlide >= slick.slideCount - slick.options.slidesToShow) { $next.addClass('slick-disabled'); } else { $next.removeClass('slick-disabled'); }
  }

  // set initial boundary classes
  var slickInstance = $('.team-join').slick('getSlick');
  updateBoundaryClasses(slickInstance, slickInstance.currentSlide);

  // on afterChange update
  $('.team-join').on('afterChange', function(event, slick, currentSlide){
    updateBoundaryClasses(slick, currentSlide);
  });


  function progress(sliders) {
    sliders.each(function () {
      var slider = jQuery(this);
      var $progressBar = slider.parentsUntil('.variable_slider_row').find('.progress');

      // Initialize progress bar on page load
      var currentSlide = slider.slick('slickCurrentSlide');
      var slideCount = slider.slick('getSlick').slideCount;
      var initialCalc = ((currentSlide + 1) / slideCount) * 100;
      $progressBar.css('background-size', initialCalc + '% 100%');

      // Update progress bar on slide change
      slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / slick.slideCount) * 100;
        $progressBar.css('background-size', calc + '% 100%');
      });

      // Also update after responsive breakpoint changes
      slider.on('breakpoint', function (event, slick, breakpoint) {
        setTimeout(function () {
          var currentSlide = slider.slick('slickCurrentSlide');
          var slideCount = slider.slick('getSlick').slideCount;
          var calc = ((currentSlide + 1) / slideCount) * 100;
          $progressBar.css('background-size', calc + '% 100%');
        }, 100);
      });
    });
  }

  progress($slider);
});
*/




jQuery(document).ready(function(){
  // initialize slick
  jQuery('.team-join').slick({
    slidesToShow: 2.2,
    slidesToScroll: 1,
    arrows: true,
    // tell slick which elements to use for prev/next
    prevArrow: jQuery('.slick-prev'),
    nextArrow: jQuery('.slick-next'),
    dots: false,
    infinite: false, // set to true if you want looping
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // OPTIONAL: add a class when first/last slide (if you need special styling)
  function updateBoundaryClasses(slick, currentSlide){
    var $prev = jQuery('.slick-prev'), $next = jQuery('.slick-next');
    if(currentSlide === 0) { $prev.addClass('slick-disabled'); } else { $prev.removeClass('slick-disabled'); }
    if(currentSlide >= slick.slideCount - Math.ceil(slick.options.slidesToShow)) {
      $next.addClass('slick-disabled');
    } else {
      $next.removeClass('slick-disabled');
    }
  }

  // set initial boundary classes (ensure instance exists)
  var $teamJoin = jQuery('.team-join');
  var slickInstance;
  try {
    slickInstance = $teamJoin.slick('getSlick');
    if (slickInstance) {
      updateBoundaryClasses(slickInstance, slickInstance.currentSlide);
    }
  } catch (e) {
    // if getSlick isn't ready yet, handle gracefully
    $teamJoin.on('init', function(event, slick){
      updateBoundaryClasses(slick, slick.currentSlide);
    });
  }

  // on afterChange update
  $teamJoin.on('afterChange', function(event, slick, currentSlide){
    updateBoundaryClasses(slick, currentSlide);
  });

  // Progress bar helper: accepts a collection of slider elements
  function progress(sliders) {
    sliders.each(function () {
      var slider = jQuery(this);
      // find the .progress element inside the same .team-scroll-area container
      var $progressBar = slider.closest('.team-scroll-area').find('.progress');

      if ($progressBar.length === 0) return; // nothing to update

      // Initialize progress bar on page load
      var currentSlide = slider.slick('slickCurrentSlide');
      var slideCount = slider.slick('getSlick').slideCount;
      var initialCalc = ((currentSlide + 1) / slideCount) * 100;
      $progressBar.css('background-size', initialCalc + '% 100%');

      // Update progress bar on slide change
      slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / slick.slideCount) * 100;
        $progressBar.css('background-size', calc + '% 100%');
      });

      // Also update after responsive breakpoint changes
      slider.on('breakpoint', function (event, slick, breakpoint) {
        setTimeout(function () {
          var currentSlide = slider.slick('slickCurrentSlide');
          var slideCount = slider.slick('getSlick').slideCount;
          var calc = ((currentSlide + 1) / slideCount) * 100;
          $progressBar.css('background-size', calc + '% 100%');
        }, 100);
      });
    });
  }

  // Call with actual jQuery collection (was $slider in your code, which didn't exist)
  progress($teamJoin);
});

















// $(".collections-wrapper").slick({
//   infinite: false,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   autoplay: false,
//   autoplaySpeed: 5000,
//   arrows: false,
//   dots: false,
//   variableWidth: true,
// });


//
$(".tab-slider").slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  arrows: true,
  dots: false,
  variableWidth: true,
});

//
jQuery('.faq-tab-slide').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

//
jQuery("#expert").slick({
  slidesToShow: 2,
  infinite: false,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  margin: 30,
  prevArrow: ".slider-prev-button",
  nextArrow: ".slider-next-button",
  // dots: false, Boolean
  // arrows: false, Boolean
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

//
jQuery("#medical_expert").slick({
  slidesToShow: 2,
  infinite: false,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  margin: 30,
  prevArrow: ".slider-prev-button",
  nextArrow: ".slider-next-button",
  // dots: false, Boolean
  // arrows: false, Boolean
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

//
jQuery('.product-filter-slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //arrows: false,
        //prevArrow: '.slider-prev-button',
        //nextArrow: '.slider-next-button',
      }
    }
  ]
});

// UpcartDrawer Cart Sync - Updates theme cart count when UpcartDrawer changes cart
(function() {
  // Function to fetch current cart and update theme's cart count
  async function syncCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();

      // Dispatch the theme's cart:change event to update cart count badge
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'upcart:sync',
          cart: cartData
        }
      }));
    } catch (error) {
      console.error('Cart sync error:', error);
    }
  }

  // Listen for UpcartDrawer-specific events (common event names)
  const upcartEvents = [
    'upcart:cart-updated',
    'upcart:item-added',
    'upcart:item-removed',
    'upcart:quantity-changed',
    'cart:updated',
    'cart.requestComplete'
  ];

  upcartEvents.forEach(function(eventName) {
    document.addEventListener(eventName, function() {
      syncCartCount();
    });
  });

  // Fallback: Monitor Shopify Ajax API calls
  // Intercept fetch calls to Shopify cart endpoints
  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];

    // Check if this is a cart-related API call
    if (typeof url === 'string' && (
      url.includes('/cart/add.js') ||
      url.includes('/cart/update.js') ||
      url.includes('/cart/change.js') ||
      url.includes('/cart/clear.js')
    )) {
      // Call original fetch
      return originalFetch.apply(this, arguments).then(function(response) {
        // After successful cart update, sync the count
        if (response.ok) {
          setTimeout(syncCartCount, 100);
        }
        return response;
      });
    }

    // For non-cart requests, just use original fetch
    return originalFetch.apply(this, arguments);
  };

  // Also intercept XMLHttpRequest for older implementations
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function() {
    if (this._url && (
      this._url.includes('/cart/add.js') ||
      this._url.includes('/cart/update.js') ||
      this._url.includes('/cart/change.js') ||
      this._url.includes('/cart/clear.js')
    )) {
      this.addEventListener('load', function() {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(syncCartCount, 100);
        }
      });
    }
    return originalSend.apply(this, arguments);
  };

  // Initial sync on page load to ensure count is correct
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartCount);
  } else {
    syncCartCount();
  }
})();